module.exports = __webpack_public_path__ + "img/tab_l.bcdb441b.png";